import route from "ziggy-js";
import { Ziggy } from "../ziggy";
import Vue from "vue";

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy)
    }
});
